export const MULTIPLE_SEND_TAG_BLOT_NAME = 'multipleSendTag'
export const MULTIPLE_SEND_TAG_TAG_NAME = 'multiplesendtag'
export const MULTIPLE_SEND_TAG_MODULE_NAME = 'multipleSendTagModule'
/**
 * 호환성을 위해 기존 클래스 명 그대로 사용
 */
export const MULTIPLE_SEND_TAG_CLASS_NAME = 'multipleSendTagButton'
export const REMOVE_MULTIPLE_SEND_TAG_EVENT_NAME = 'remove-multiple-send-tag'
